import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-modal-add-permissao-csv',
  templateUrl: './modal-add-permissao-csv.component.html',
  styleUrls: ['./modal-add-permissao-csv.component.scss']
})
export class ModalAddPermissaoCsvComponent implements OnInit {
  @Input() corPrimaria: string;
  @Output() fecharModal = new EventEmitter();

  cpf: any;

  constructor(
    private loading: NgxSpinnerService,
    private toast: ToastrService,
  ) {
  }

  ngOnInit() {
  }

  fechar() {
    this.fecharModal.emit(false);
  }

  adicionar() {
    console.log('this.cpf.length', this.cpf.length);
    if (this.cpf.length < 14) {
      this.toast.error('Atenção! CPF com formato inválido.');
    } else {
      this.fecharModal.emit({cpf: this.cpf.replace(/\D/g, '')});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-add-permissao-csv/modal-add-permissao-csv.component.ts